export default __webpack_public_path__ + "static/media/foie.201f235e.jpg";